import { render } from "./App.vue?vue&type=template&id=4ffbae24"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4ffbae24&lang=scss"

import exportComponent from "/var/www/clients/client1/web6/web/cartamovil-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__